export const PLP_BANNER_MOBILE_COLUMNS = 2;
export const PLP_BANNER_DESKTOP_COLUMNS = 4;

export type ShouldShowPlpBannerParams = {
  pageIndex: number;
  itemCount: number;
  columns: number;
  hasContent: boolean;
};

export const shouldShowPlpBanner = ({
  pageIndex,
  itemCount,
  columns,
  hasContent,
}: ShouldShowPlpBannerParams): boolean => {
  if (!hasContent) {
    return false;
  }

  if (pageIndex !== 0) {
    return false;
  }

  if (itemCount === 0) {
    return false;
  }

  return itemCount >= columns * 2;
};
